import { render, staticRenderFns } from "./EditGlobalSettings.vue?vue&type=template&id=5ce955e6&scoped=true"
import script from "./EditGlobalSettings.vue?vue&type=script&lang=js"
export * from "./EditGlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./EditGlobalSettings.vue?vue&type=style&index=0&id=5ce955e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce955e6",
  null
  
)

export default component.exports